var map = {
	"./2.jpg": 2785,
	"./QA.jpg": 2217,
	"./arrow-enter.svg": 4337,
	"./basic.jpg": 737,
	"./basicNew.jpg": 3971,
	"./basicNew_ (1).jpg": 1554,
	"./basicNew_ (2).jpg": 6039,
	"./manufactory.jpg": 4474,
	"./old/basic.jpg": 9287,
	"./old/plants.png": 9115,
	"./old/transformator.png": 4093,
	"./old/turbina.png": 7544,
	"./old/turbo-main.png": 3403,
	"./trans-1.jpg": 1535,
	"./trans-old.jpg": 481,
	"./trans.jpg": 9261,
	"./transformator.png": 915,
	"./turb.jpg": 3270,
	"./turbina.png": 4530,
	"./turbo-main.jpg": 5005,
	"./turbo-main.png": 1837
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1627;